import { AttributeBase, AttributeOptions } from './attribute-base';

export class DropdownAttribute extends AttributeBase<string> {
  public override controlType: string;
  public override options = [];
  public override type: string;

  constructor(dropdownOptions: AttributeOptions = {}) {
    super(dropdownOptions);
    this.options = dropdownOptions['options'] || [];
  }
}
